export default [{
	path: 'examine',
	meta: {
		title: '接驳'
	},
	component: () => import('@/pages/other/examine')
}, {
	path: 'unicode',
	meta: {
		title: '背贴码跟踪'
	},
	props: route => route.query,
	component: () => import('@/pages/other/unicode')
}, {
	path: 'kanban',
	meta: {
		title: '编辑数据看板'
	},
	component: () => import('@/pages/other/kanban_config')
}, {
	path: 'withdraw/order',
	meta: {
		title: '选择提现订单'
	},
	component: () => import('@/pages/other/withdraw_order')
}, {
	path: 'agreement/:type',
	meta: {
		loginFree: true
	},
	props: route => route.params,
	component: () => import('@/pages/other/agreement')
}, {
	path: 'article/:type',
	meta: {
		title(route) {
			return {
				1: '通知公告',
				2: '新手入门',
				3: '规则规范'
			}[route.params.type]
		},
	},
	props: route => route.params,
	component: () => import('@/pages/other/article')
}, {
	path: 'article/:type/:id',
	meta: {
		title(route) {
			return {
				1: '通知公告',
				2: '新手入门',
				3: '规则规范'
			}[route.params.type]
		},
	},
	props: route => route.params,
	component: () => import('@/pages/other/article_detail')
}]